/**
 * Removes @id attributes from an object (recursively)
 * @param {Object} obj - The object to clean
 * @returns {Object} - New object without @id attributes
 */
export function removeIdAttributes(obj: Record<string, any>): Record<string, any> {
    if (!obj || typeof obj !== 'object') return obj;
    
    if (Array.isArray(obj)) {
        return obj.map(item => removeIdAttributes(item));
    }
    
    // For objects, create a new copy without @id
    const result: Record<string, any> = {};
    for (const key in obj) {
        if (key !== '@id') {
            result[key] = removeIdAttributes(obj[key]);
        }
    }
    
    return result;
};